(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8155],{

/***/ 92089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42670);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48089);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25655);







var FormErrorMessage = function(param) {
    var _errors = param.errors, errors = _errors === void 0 ? [] : _errors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: errors.map(function(error) {
            var message = _messages__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[error.id];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .j, {
                "data-testid": error.id,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, message), {
                    values: error.values
                }))
            }, error.id);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormErrorMessage);


/***/ }),

/***/ 25655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49177);

var messages = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessages */ .vU)({
    required: {
        id: "validation.required"
    },
    minLength: {
        id: "validation.min"
    },
    maxLength: {
        id: "validation.max"
    },
    invalid: {
        id: "validation.invalid"
    },
    fillField: {
        id: "validation.fill-field"
    },
    validEmail: {
        id: "login.valid-email"
    },
    pleaseEmail: {
        id: "subscription.please-enter-your-email"
    },
    pleaseEnterPassword: {
        id: "subscription.please-enter-password"
    },
    passwordLength: {
        id: "global.password-length"
    },
    subscriptionRepeatPassword: {
        id: "subscription.repeat-password"
    },
    legalTerms: {
        id: "legal.terms-validation"
    },
    passwordDifferent: {
        id: "login.password-different"
    },
    paxNames: {
        id: "error.room-names"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (messages);


/***/ }),

/***/ 52439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SubscriptionBoxConnected": function() { return /* binding */ SubscriptionBoxConnected; },
  "default": function() { return /* binding */ homeV2_SubscriptionBoxConnected; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./client/components/FormErrorMessage/index.tsx
var FormErrorMessage = __webpack_require__(92089);
// EXTERNAL MODULE: ./client/helpers/Form/index.ts + 1 modules
var Form = __webpack_require__(5766);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/Button/index.tsx
var Button = __webpack_require__(9961);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/constants.js
var constants = __webpack_require__(26111);
// EXTERNAL MODULE: ./src/comps/Molecules/Subscription/styles.module.css
var styles_module = __webpack_require__(59378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/Subscription/SubscriptionErrorMsg/index.tsx




function SubscriptionErrorMsg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
        className: (styles_module_default()).subscriptionBoxTitle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "error.default"
        })
    });
}

// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./src/comps/Molecules/Subscription/SubscriptionSuccessMsg/index.tsx





function SubscriptionSuccessMsg() {
    var feedbackMessageType = (0,useMarket/* useMarket */.A)().feedbackMessageType;
    var subtitleMessageId = feedbackMessageType === "text" ? "subscription.thank-you-for-being-part-of-our-community" : "subscription.we-have-sent-you-an-email";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: (styles_module_default()).subscriptionBoxTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "global.thank-you"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).subscriptionBoxSubTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: subtitleMessageId
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/comps/Molecules/Subscription/SubscriptionBox/styles.module.css
var SubscriptionBox_styles_module = __webpack_require__(55971);
var SubscriptionBox_styles_module_default = /*#__PURE__*/__webpack_require__.n(SubscriptionBox_styles_module);
;// CONCATENATED MODULE: ./src/comps/Molecules/Subscription/SubscriptionBox/index.tsx











function SubscriptionBox(props) {
    var status = props.status, onSubscribe = props.onSubscribe, _bgColor = props.bgColor, bgColor = _bgColor === void 0 ? "" : _bgColor, _variant = props.variant, variant = _variant === void 0 ? "section" : _variant, title = props.title, description = props.description, buttonText = props.buttonText, buttonBgColor = props.buttonBgColor, buttonTextColor = props.buttonTextColor;
    var isMinimal = variant === "minimal";
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)([]), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)(false), formSubmitted = ref2[0], setFormSubmitted = ref2[1];
    var intl = (0,useIntl/* default */.Z)();
    var handleSubmit = function(e) {
        e.preventDefault();
        setFormSubmitted(true);
        if ((0,Form/* validateEmail */.oH)(email)) {
            setErrors([
                {
                    id: "validEmail"
                }
            ]);
            return;
        }
        setErrors([]);
        onSubscribe(email);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SubscriptionBox_styles_module_default()).base,
        "data-variant": variant,
        style: {
            "--bg-color": bgColor,
            "--button-bg-color": buttonBgColor,
            "--button-text-color": buttonTextColor
        },
        "data-testid": "subscription-box",
        children: [
            (status === constants/* SUBSCRIBED */.Wx || status === constants/* PENDING */.hA) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionSuccessMsg, {}),
            formSubmitted && status === constants/* UNSUBSCRIBED */.$y && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionErrorMsg, {}),
            status === constants/* UNSUBSCRIBED */.$y && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !isMinimal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: (styles_module_default()).subscriptionBoxTitle,
                                children: title || /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "subscription.subscribe-to-get-unique-discounts"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default()).subscriptionBoxSubTitle,
                                children: description || /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "subscription.on-our-newsletter"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (SubscriptionBox_styles_module_default()).form,
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: (SubscriptionBox_styles_module_default()).input,
                                placeholder: intl.formatMessage({
                                    id: "global.email"
                                }),
                                value: email,
                                onChange: function(e) {
                                    setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (SubscriptionBox_styles_module_default()).button,
                                size: "m",
                                type: "button",
                                onClick: handleSubmit,
                                "data-custom-bg": !!buttonBgColor,
                                "data-custom-color": !!buttonTextColor,
                                children: buttonText || /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "subscription.subscribe-cta"
                                })
                            })
                        ]
                    }),
                    errors && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
                        errors: errors
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/selectors.js
var selectors = __webpack_require__(72926);
// EXTERNAL MODULE: ./src/effects/SubscriptionStatus/actions.js
var actions = __webpack_require__(92186);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
// EXTERNAL MODULE: ./src/constants/environment.js
var environment = __webpack_require__(65003);
;// CONCATENATED MODULE: ./src/pages/homeV2/SubscriptionBoxConnected/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-block: 80px;\n  padding-inline: 80px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n\n  ",
        " {\n    background-image: none;\n    grid-template-columns: 1fr;\n    padding-block: 0;\n    padding-inline: 0;\n    gap: 0;\n  }\n\n  ",
        " {\n    padding-block: 32px;\n    padding-inline: 32px;\n    grid-template-columns: 1fr;\n    gap: 0;\n    background-size: cover;\n    background-image: url(",
        "/subscription_box/img-newsletter_768x400.webp);\n  }\n  ",
        " and (resolution: 2dppx) {\n    background-image: url(",
        "/subscription_box/img-newsletter_1536x400.webp);\n  }\n  ",
        " and (resolution: 3dppx) {\n    background-image: url(",
        "/subscription_box/img-newsletter_2304x400.webp);\n  }\n\n  ",
        " {\n    background-image: url(",
        "/subscription_box/img-newsletter_1024x400.webp);\n  }\n  ",
        " and (resolution: 2dppx) {\n    background-image: url(",
        "/subscription_box/img-newsletter_2048x400.webp);\n  }\n  ",
        " and (resolution: 3dppx) {\n    background-image: url(",
        "/subscription_box/img-newsletter_3096x400.webp);\n  }\n\n  @media (min-width: 1280px) {\n    background-image: url(",
        "/subscription_box/img-newsletter_1920x400.webp);\n  }\n  @media (min-width: 1280px) and (resolution: 2dppx) {\n    background-image: url(",
        "/subscription_box/img-newsletter_3840x400.webp);\n  }\n  @media (min-width: 1280px) and (resolution: 3dppx) {\n    background-image: url(",
        "/subscription_box/img-newsletter_5760x400.webp);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: var(--layout-max-width);\n  display: grid;\n  margin-block: 0;\n  margin-inline: auto;\n  grid-template-columns: 1fr;\n  gap: 0;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n    gap: 80px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var SubscriptionBoxConnectedBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SubscriptionBoxConnectedBase",
    componentId: "sc-d06bbed7-0"
})(_templateObject(), styles/* updatedMedia.onlyMobile */.$c.onlyMobile, styles/* updatedMedia.onlyTablet */.$c.onlyTablet, environment/* PATH_IMAGES_CDN */.VZ, styles/* updatedMedia.onlyTablet */.$c.onlyTablet, environment/* PATH_IMAGES_CDN */.VZ, styles/* updatedMedia.onlyTablet */.$c.onlyTablet, environment/* PATH_IMAGES_CDN */.VZ, styles/* updatedMedia.desktop */.$c.desktop, environment/* PATH_IMAGES_CDN */.VZ, styles/* updatedMedia.desktop */.$c.desktop, environment/* PATH_IMAGES_CDN */.VZ, styles/* updatedMedia.desktop */.$c.desktop, environment/* PATH_IMAGES_CDN */.VZ, environment/* PATH_IMAGES_CDN */.VZ, environment/* PATH_IMAGES_CDN */.VZ, environment/* PATH_IMAGES_CDN */.VZ);
var SubscriptionBoxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SubscriptionBoxContainer",
    componentId: "sc-d06bbed7-1"
})(_templateObject1(), styles/* updatedMedia.desktop */.$c.desktop);
var Spacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Spacer",
    componentId: "sc-d06bbed7-2"
})(_templateObject2(), styles/* updatedMedia.onlyMobile */.$c.onlyMobile, styles/* updatedMedia.onlyMobile */.$c.onlyMobile);

;// CONCATENATED MODULE: ./src/pages/homeV2/SubscriptionBoxConnected/index.tsx








function SubscriptionBoxConnected(param) {
    var source = param.source, _variant = param.variant, variant = _variant === void 0 ? "section" : _variant, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#B494F9" : _bgColor, title = param.title, description = param.description, buttonText = param.buttonText, buttonBgColor = param.buttonBgColor, buttonTextColor = param.buttonTextColor;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, feedbackMessageType = ref.feedbackMessageType, market = ref.market;
    var subscriptionStatus = (0,es/* useSelector */.v9)(selectors/* getSubscriptionStatus */.ku);
    var handleSubscribe = function(emailToSubscribe) {
        dispatch((0,actions/* subscribeRequestAction */.k2)({
            hash: emailToSubscribe,
            language: language,
            market: market,
            feedbackMessageType: feedbackMessageType,
            source: source
        }));
    };
    if (variant === "box" || variant === "minimal") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionBox, {
            onSubscribe: handleSubscribe,
            status: subscriptionStatus,
            bgColor: bgColor,
            variant: variant,
            title: title,
            description: description,
            buttonText: buttonText,
            buttonBgColor: buttonBgColor,
            buttonTextColor: buttonTextColor
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionBoxConnectedBase, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionBoxContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionBox, {
                    onSubscribe: handleSubscribe,
                    status: subscriptionStatus,
                    bgColor: bgColor,
                    variant: variant,
                    title: title,
                    description: description,
                    buttonText: buttonText,
                    buttonBgColor: buttonBgColor,
                    buttonTextColor: buttonTextColor
                })
            ]
        })
    });
}
/* harmony default export */ var homeV2_SubscriptionBoxConnected = (SubscriptionBoxConnected);


/***/ }),

/***/ 55971:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__tGaEL","form":"styles_form__W4D7B","input":"styles_input__u3wwf","button":"styles_button__1ZHR_"};

/***/ }),

/***/ 59378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscriptionBoxTitle":"styles_subscriptionBoxTitle__UWP6F","subscriptionBoxSubTitle":"styles_subscriptionBoxSubTitle__Rm7Nq"};

/***/ })

}]);